import React, {useState, useEffect} from 'react';

import Modal from '../../components/ModalNew';
import Button, {ButtonSizes} from '../../components/ButtonNew';
import {useAnalytics} from '../../hooks';

const QUESTIONS_UNTIL_SHOWN = 3;
const MS_BETWEEN_MODAL = 7 * 86400000; // 7 days * 86400000 ms in a day

export const incrementQuestionViews = () => {
  const questionsViewed = parseInt(sessionStorage.getItem('questionsViewed') || 0, 10);
  sessionStorage.setItem('questionsViewed', questionsViewed + 1);
};

const AddQuestionModal = () => {
  const {tracker} = useAnalytics();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const numQuestionsViewed = parseInt(sessionStorage.getItem('questionsViewed') || 0, 10);
    const timeOfLastModal = parseInt(localStorage.getItem('timeOfLastContributeModal') || 0, 10);

    if ((numQuestionsViewed >= QUESTIONS_UNTIL_SHOWN)
    && (Date.now() - timeOfLastModal > MS_BETWEEN_MODAL)) {
      localStorage.setItem('timeOfLastContributeModal', Date.now());
      tracker.questionListViewContributeModal();
      setOpen(true);
    }
  }, []);

  return (
    <Modal
      isOpen={open}
      onClose={() => setOpen(false)}
      showCloseButton
    >
      <div className="w-full text-left flex flex-col">
        <h3 className="text-lg font-semibold mb-3 text-gray-900">
          Have you interviewed recently?
        </h3>
        <p className="mb-5 text-base font-normal text-gray-600">
          Help the Exponent community stay up-to-date by anonymously
          sharing your recent interview experiences.
        </p>
        <div className="w-full flex flex gap-2">
          <Button
            className="w-full"
            href="/questions/contribute"
            size={ButtonSizes.LARGE}
            onClick={() => tracker.questionListClickContribute({button: 'modal'})}
          >
            {'Tell us about your interview ->'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddQuestionModal;
